import { Feature, Permissions } from 'src/api/api.generated'
import { IfGrantedProps } from './if-granted'

//#region Permissions for 1st level pages (are pages belong to main menu)

export enum HicPages {
  DASHBOARD,
  PLANNING,
  RESERVATIONS,
  QUOTATIONS,
  CUSTOMERS,
  BILLS,
  PRICES_CALENDAR,
  POS,
  PASSERBY_BILLS,
  STATISTICS,
  SETTINGS,
  HOUSEKEEPING,
  SINAPSI,
  SUPPORT,
  MESSAGES,
  AUDITS,
  AUTOMATION_API,
}

export const firstLevelPagesPermissions = new Map<HicPages, IfGrantedProps>([
  [HicPages.DASHBOARD, { modules: ['PMS', 'CM', 'BE'], permissions: [Permissions.BASE] }],

  [HicPages.PLANNING, { modules: ['PMS'], permissions: [Permissions.BASE] }],

  [HicPages.RESERVATIONS, { modules: ['PMS', 'CM', 'BE'], permissions: [Permissions.BOOKING] }],

  [HicPages.QUOTATIONS, { modules: ['PMS'], permissions: [Permissions.BOOKING] }],

  [HicPages.CUSTOMERS, { modules: ['PMS', 'CM', 'BE'], permissions: [Permissions.BASE] }],

  [HicPages.BILLS, { modules: ['PMS'], permissions: [Permissions.BOOKING] }],

  [HicPages.PRICES_CALENDAR, { modules: ['PMS', 'CM', 'BE'], permissions: [Permissions.BOOKING] }],

  [HicPages.POS, { modules: ['PMS'], permissions: [Permissions.POS, Permissions.BOOKING] }],

  [HicPages.PASSERBY_BILLS, { modules: ['PMS'], permissions: [Permissions.BOOKING] }],

  [HicPages.STATISTICS, { modules: ['PMS'], permissions: [Permissions.STATISTICS] }],

  [HicPages.SETTINGS, { modules: ['PMS', 'CM', 'BE'], permissions: [Permissions.BOOKING, Permissions.CONFIG] }],

  [HicPages.HOUSEKEEPING, { modules: ['PMS'], permissions: [Permissions.HOUSEKEEPER, Permissions.BOOKING], features: [Feature.HOUSEKEEPER] }],

  [HicPages.SETTINGS, { modules: ['PMS', 'CM', 'BE'], permissions: [Permissions.BOOKING, Permissions.CONFIG] }],

  [HicPages.SINAPSI, { modules: ['PMS', 'RM'], permissions: [Permissions.BOOKING] }],

  [HicPages.MESSAGES, { modules: ['PMS'], permissions: [Permissions.BASE] }],

  [HicPages.AUTOMATION_API, { modules: ['PMS'], permissions: [Permissions.CONFIG], features: [Feature.AUTOMATION_API, Feature.AUTOMATION] }],
])

//#endregion

//

//#region Permission for pages of setting section

export enum HicSettingsPages {
  SETTINGS_COMMON_PERMISSION,
  RATES,
  CHANNELS,
  CHARGES,
}

export const settingsPagesPermissions = new Map<HicSettingsPages, IfGrantedProps>([
  [HicSettingsPages.SETTINGS_COMMON_PERMISSION, { modules: ['PMS', 'CM', 'BE'], permissions: [Permissions.CONFIG] }],
  [HicSettingsPages.RATES, { modules: ['PMS', 'CM', 'BE'], permissions: [Permissions.BOOKING, Permissions.CONFIG] }],
  [HicSettingsPages.CHANNELS, { modules: ['CM'], permissions: [Permissions.CONFIG] }],
  [HicSettingsPages.CHARGES, { modules: ['PMS'], permissions: [Permissions.CONFIG] }],
])

//#endregion

//

//#region Permission of reservation sub pages

export enum HicReservationPages {
  DETAILS,
  DATAILS_EDIT,
}

export const reservationPagesPermissions = new Map<HicReservationPages, IfGrantedProps>([
  [HicReservationPages.DETAILS, { modules: ['PMS', 'CM', 'BE'], permissions: [Permissions.BASE, Permissions.BOOKING] }],
  [HicReservationPages.DATAILS_EDIT, { modules: ['PMS', 'CM', 'BE'], permissions: [Permissions.BOOKING] }],
])

//#endregion

//

//#region Other operations permissions

export enum HicOperations {
  CREATE_RESERVATION,
  CHECKOUT,
  CHECKIN,
  ADVANCED_STATISTICS,
}

export const hicOperationsPermissions = new Map<HicOperations, IfGrantedProps>([
  [HicOperations.CREATE_RESERVATION, { permissions: [Permissions.BOOKING] }],
  [HicOperations.CHECKIN, { permissions: [Permissions.BOOKING] }],
  [HicOperations.CHECKOUT, { permissions: [Permissions.BOOKING] }],
  [HicOperations.ADVANCED_STATISTICS, { permissions: [Permissions.STATISTICS] }],
])

//#endregion
